export default "__VITE_ASSET__0b5859b5__"